import type { ButtonElementValue } from '@vedalib/editor/lib/elements'
import { ButtonActionType } from '@vedalib/editor/lib/elements'

import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import BaseButtonElement from './BaseButtonElement'
import type { ButtonDemoType } from './buttonTypes'

const DEMO_VALUE: ButtonElementValue = {
  label: t('elements.button.label'),
  actionType: ButtonActionType.navigation,
}

export const ButtonDemo: ButtonDemoType = ({ styles, fonts }) => {
  return (
    <DemoWrapper center>
      <BaseButtonElement font={fonts} label={DEMO_VALUE.label} mode={DEMO_MODE} styles={styles} />
    </DemoWrapper>
  )
}
export const ButtonDemoDisabled: ButtonDemoType = ({ styles, fonts }) => {
  return (
    <DemoWrapper center>
      <BaseButtonElement
        font={fonts}
        label={DEMO_VALUE.label}
        mode={DEMO_MODE}
        styles={styles}
        disabled
      />
    </DemoWrapper>
  )
}
